var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{class:_vm.classes.imageSize,attrs:{"name":_vm.formatToFileName(_vm.getDepartmentDisplayName(_vm.departmentName)),"color":_vm.$vuetify.theme.themes.light.primary,"title":_vm.getDepartmentDisplayName(_vm.departmentName)+' department icon',"no-image":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }